import Component from 'routes/Search'

const defaultProps = {}
const propTypes = {}

export const Page = props => <Component {...props} />

Page.defaultProps = defaultProps
Page.propTypes = propTypes

export default Page
